import React from 'react';
import { projects } from '../data/projects';
import ProjectCard from './ProjectCard';
import '../styles/Projects.css';

const Projects: React.FC = () => {
    return (
        <section className="projects section" id="projects">
            <h1>Projects</h1>
            <div className="project-list">
                {projects.map((project, index) => (
                    <ProjectCard key={index} project={project} />
                ))}
            </div>
        </section>
    );
};

export default Projects;
